<template>
    <div class="container">
        <div class="title">{{$l('download/title')}}</div>
        <div class="options">
            <div @click="xmlClicked" class="option">{{$l('download/popOver/XML')}}</div>
            <div @click="xmlWeeklyClicked" class="option">{{$l('download/popOver/XMLWeekly')}}</div>
            <div @click="rawClicked" class="option">{{$l('download/popOver/Raw')}}</div>
            <div @click="globalClicked" class="option">{{$l('download/popOver/Global')}}</div>
            <div @click="weathClicked" class="option">{{$l('download/popOver/weather')}}</div>
        </div>
    </div>
</template>


<style scoped>
    .container{
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        
    }
    .title{
        border-bottom:1px solid #e9edef ;
        padding-bottom: 10px;
        font-size: 15px;
        margin-bottom: 5px;
        text-align: center;
        font-weight: 600;
    }
    .option{
        text-align: center;
        padding: 5px;
        cursor: default;
    }
    .option:hover{
        background-color: rgba(0,0,0,0.05);
    }
    .option.disabled{
        color:#e9edef;
    }
    .option.disabled:hover{
        background-color: transparent;
    }

</style>

<script>
import {getUrlEncodedMeasurementHourFile, getUrlEncodedMeasurementDayFile, getUrlEncodedDateTime,  getWeekDays} from '@/common/utils';
import { mapGetters, mapActions } from 'vuex'
import * as api from '@/api'

export default {
    computed:{
        ...mapGetters([
            'getSelectedDay',
            'getSelectedHour',
            'getLocalSettings',
            'getSelectedInterval'
        ]),
        hasHours: function(){
            if(this.getSelectedHour !='') return true;
            else return false;
        }
    },
    methods:{
        ...mapActions([
            'setDownloading',
            'setDownloadingProgress'
        ]),
        xmlClicked: function(){
            var selectedTime = new Date(Date.UTC(this.getSelectedDay.year, this.getSelectedDay.month, this.getSelectedDay.day, this.getSelectedHour));
            var localSettings = this.getLocalSettings;
            var downloadNoise = [];
            Object.keys(localSettings.download.downlnoise).forEach(function (key) {
                if(localSettings.download.downlnoise[key])
                    downloadNoise.push(key);
            });
            var downloadWeather = [];
            Object.keys(localSettings.download.downlweath).forEach(function (key) {
                if(localSettings.download.downlweath[key])
                    downloadWeather.push(key);
            });

            var other_arr = [];
           // if(localSettings.download.audio && localSettings.download.video) other = '&othr=audio,video'
           // if(!localSettings.download.audio && localSettings.download.video) other = '&othr=video'
           // if(localSettings.download.audio && !localSettings.download.video) other = '&othr=audio'
            if(localSettings.download.video) other_arr.push("video");
            if(localSettings.download.audio) other_arr.push("audio");
            if(localSettings.download.markers) other_arr.push("markers");
            var other = "&othr=" + other_arr.toString();
            //./api/download-xml&measurement=yyyy-mm-dd--HH&param=Noise values&paramw=Weather values&other=audio/video
            var url = '';
        
            var startInt = undefined;
            var endInt = undefined;
            if (this.getSelectedInterval.start){
                startInt = getUrlEncodedDateTime(this.getSelectedInterval.start);
            }
            if (this.getSelectedInterval.end){
                endInt = getUrlEncodedDateTime(this.getSelectedInterval.end);

            }
            if (startInt !== undefined) {
                startInt += ".000"
            }
            if (endInt !== undefined) {
                endInt += ".000"
            }
            if(this.hasHours){
                url = '/api/download-xml&measurement='+getUrlEncodedMeasurementHourFile(selectedTime)+'&param='+downloadNoise.join(',')+'&paramw='+downloadWeather.join(',')+other+'&start='+startInt+'&stop='+endInt+'&time='+Date.now();
            }else{
                url = '/api/download-xml&measurement='+getUrlEncodedMeasurementDayFile(selectedTime)+'&param='+downloadNoise.join(',')+'&paramw='+downloadWeather.join(',')+other+'&start='+startInt+'&stop='+endInt+'&time='+Date.now();
            }
            url = url.replace(/ /g, '_');
            this.setDownloading({enabled: true, progress: 0, preparing:true})
                api.getFileAction(url,'GET','', (progress)=>{
                    let percentage = 100;
                    if (progress.total != 0) {
                        percentage = Math.round((progress.loaded/progress.total)*100);
                    }
                    this.setDownloadingProgress(percentage);
                })
                .then(()=>{
                    this.setDownloading({enabled: false, progress: 0})
                })
                .catch(()=>{
                    this.setDownloading({enabled: false, progress: 0})
                    
                })
            //window.location.href = url;
        },
        xmlWeeklyClicked: function(){
            var selectedDay = new Date(Date.UTC(this.getSelectedDay.year, this.getSelectedDay.month, this.getSelectedDay.day, this.getSelectedHour));
            var days = getWeekDays(selectedDay).join(',');
            var localSettings = this.getLocalSettings;
            var downloadNoise = [];
            Object.keys(localSettings.download.downlnoise).forEach(function (key) {
                if(localSettings.download.downlnoise[key])
                    downloadNoise.push(key);
            });
            var downloadWeather = [];
            Object.keys(localSettings.download.downlweath).forEach(function (key) {
                if(localSettings.download.downlweath[key])
                    downloadWeather.push(key);
            });

            var other_arr = [];
           // if(localSettings.download.audio && localSettings.download.video) other = '&othr=audio,video'
            //if(!localSettings.download.audio && localSettings.download.video) other = '&othr=video'
            //if(localSettings.download.audio && !localSettings.download.video) other = '&othr=audio'

            if(localSettings.download.video) other_arr.push("video");
            if(localSettings.download.audio) other_arr.push("audio");
            if(localSettings.download.markers) other_arr.push("markers");
            var other = "&othr=" + other_arr.toString();

            var url = '/api/download-xml&measurement='+days+'&param='+downloadNoise.join(',')+'&paramw='+downloadWeather.join(',')+other+'&time='+Date.now();
            this.setDownloading({enabled: true, progress: 0, preparing:true})
                api.getFileAction(url,'GET','', (progress)=>{
                    let percentage = 100;
                    if (progress.total != 0) {
                        percentage = Math.round((progress.loaded/progress.total)*100);
                    }
                    this.setDownloadingProgress(percentage);
                })
                .then(()=>{
                    this.setDownloading({enabled: false, progress: 0})
                })
                .catch(()=>{
                    this.setDownloading({enabled: false, progress: 0})
                    
                })
            //window.location.href = url;
        },
        rawClicked:function(){
            var date = ''

            var localSettings = this.getLocalSettings;
            var downloadNoise = [];
            var downloadWeather = [];

            Object.keys(localSettings.download.downlnoise).forEach(key=>{ if(localSettings.download.downlnoise[key]) downloadNoise.push(key); });
            Object.keys(localSettings.download.downlweath).forEach(key=>{ if(localSettings.download.downlweath[key]) downloadWeather.push(key); });

            if(!this.hasHours || (this.getSelectedInterval.end && this.getSelectedInterval.start)){
                var selectedTime = new Date(Date.UTC(this.getSelectedDay.year, this.getSelectedDay.month, this.getSelectedDay.day));                    
                date = getUrlEncodedMeasurementDayFile(selectedTime);
                var url = '';
                if((this.getSelectedInterval.end && this.getSelectedInterval.start))
                {
                    //./api/download-day &measurement=yyyy-mm-dd&param=Noise values&paramw=Weather values&start=yyyy-mm-dd HH:MM:SS.fff&stop=yyyy-mm-dd HH:MM:SS.fff&zip=0/1
                    var start = getUrlEncodedDateTime(this.getSelectedInterval.start);
                    var end = getUrlEncodedDateTime(this.getSelectedInterval.end);
                    if (start !== undefined) {
                        start += ".000"
                    }
                    if (end !== undefined) {
                        end += ".000"
                    }
                    url = '/api/download-day&measurement='+ date +'&param='+downloadNoise.join(',')+'&paramw='+downloadWeather.join(',')+'&start='+start+'&stop='+end+'&zip='+localSettings.download.downlzip+'&time='+Date.now();
                }
                else{
                    url = '/api/download-day&measurement='+ date +'&param='+downloadNoise.join(',')+'&paramw='+downloadWeather.join(',')+'&zip='+localSettings.download.downlzip+'&time='+Date.now();
                }

                url = url.replace(/ /g, '_');

                this.setDownloading({enabled: true, progress: 0, preparing:true})
                api.getFileAction(url,'GET','', (progress)=>{
                    let percentage = 100;
                    if (progress.total != 0) {
                        percentage = Math.round((progress.loaded/progress.total)*100);
                    }
                    this.setDownloadingProgress(percentage);
                })
                .then(()=>{
                    this.setDownloading({enabled: false, progress: 0})
                })
                .catch(()=>{
                    this.setDownloading({enabled: false, progress: 0})
                    
                })
                //window.location.href = (url.replace(/ /g, '_'));
            }
            else{
                var selectedTime = new Date(Date.UTC(this.getSelectedDay.year, this.getSelectedDay.month, this.getSelectedDay.day, this.getSelectedHour));
                date = getUrlEncodedMeasurementHourFile(selectedTime);
                var url = '/api/download-raw&measurement='+ date +'&param='+downloadNoise.join(',')+'&paramw='+downloadWeather.join(',')+'&zip='+localSettings.download.downlzip+'&time='+Date.now();
                //alert(url);

                url = url.replace(/ /g, '_');

                this.setDownloading({enabled: true, progress: 0, preparing:true})
                api.getFileAction(url,'GET','', (progress)=>{
                    let percentage = 100;
                    if (progress.total != 0) {
                        percentage = Math.round((progress.loaded/progress.total)*100);
                    }
                    this.setDownloadingProgress(percentage);
                })
                .then(()=>{
                    this.setDownloading({enabled: false, progress: 0})
                })
                .catch(()=>{
                    this.setDownloading({enabled: false, progress: 0})
                    
                })
                //window.location.href = (url.replace(/ /g, '_'));                
            }

            //./api/download-raw&measurement=yyyy-mm-dd-HH&param=Noise values&paramw=Weather values&zip=0/1
        },
        globalClicked: function(){
            var selectedTime = new Date(Date.UTC(this.getSelectedDay.year, this.getSelectedDay.month, this.getSelectedDay.day));
            var localSettings = this.getLocalSettings;
            var downloadGlobal = [];
            Object.keys(localSettings.download.downlGlobal).forEach(key=>{if(localSettings.download.downlGlobal[key]) downloadGlobal.push(key); });

            //./api/download-global&measurement=yyyy-mm-dd&param=Global values&zip=0/1

            var startInt = undefined;
            var endInt = undefined;
            if (this.getSelectedInterval.start){
                startInt = getUrlEncodedDateTime(this.getSelectedInterval.start);
            }
            if (this.getSelectedInterval.end){
                endInt = getUrlEncodedDateTime(this.getSelectedInterval.end);

            }
            if (startInt !== undefined) {
                    startInt += ".000"
            }
            if ( endInt !== undefined) {
                endInt += ".000"
            }

            var url ='/api/download-global&measurement='+getUrlEncodedMeasurementDayFile(selectedTime)+'&param='+downloadGlobal.join(',')+'&zip='+localSettings.download.downlzip+'&start='+startInt+'&stop='+endInt+'&time='+Date.now();
            
            this.setDownloading({enabled: true, progress: 0, preparing:true})
                api.getFileAction(url,'GET','', (progress)=>{
                    let percentage = 100;
                    if (progress.total != 0) {
                        percentage = Math.round((progress.loaded/progress.total)*100);
                    }
                    this.setDownloadingProgress(percentage);
                })
                .then(()=>{
                    this.setDownloading({enabled: false, progress: 0})
                })
                .catch(()=>{
                    this.setDownloading({enabled: false, progress: 0})
                    
                })
            //window.location.href = url;
        },
        weathClicked:function(){
            var date = ''

            var localSettings = this.getLocalSettings;
            var downloadWeather = [];

            Object.keys(localSettings.download.downlweath).forEach(key=>{ if(localSettings.download.downlweath[key]) downloadWeather.push(key); });

            if(!this.hasHours || (this.getSelectedInterval.end && this.getSelectedInterval.start)){
                var selectedTime = new Date(Date.UTC(this.getSelectedDay.year, this.getSelectedDay.month, this.getSelectedDay.day));                    
                date = getUrlEncodedMeasurementDayFile(selectedTime);
                var url = '';
                if((this.getSelectedInterval.end && this.getSelectedInterval.start))
                {
                    var start = getUrlEncodedDateTime(this.getSelectedInterval.start);
                    var end = getUrlEncodedDateTime(this.getSelectedInterval.end);
                    if (start !== undefined) {
                        start += ".000"
                    }
                    if (end !== undefined) {
                        end += ".000"
                    }
                    url = '/api/download-weather-day&measurement='+ date+'&paramw='+downloadWeather.join(',')+'&start='+start+'&stop='+end+'&zip='+localSettings.download.downlzip+'&time='+Date.now();
                }
                else{
                    url = '/api/download-weather-day&measurement='+ date+'&paramw='+downloadWeather.join(',')+'&zip='+localSettings.download.downlzip+'&time='+Date.now();
                }

                url = url.replace(/ /g, '_');
                this.setDownloading({enabled: true, progress: 0, preparing:true})
                api.getFileAction(url,'GET','', (progress)=>{
                    let percentage = 100;
                    if (progress.total != 0) {
                        percentage = Math.round((progress.loaded/progress.total)*100);
                    }
                    this.setDownloadingProgress(percentage);
                })
                .then(()=>{
                    this.setDownloading({enabled: false, progress: 0})
                })
                .catch(()=>{
                    this.setDownloading({enabled: false, progress: 0})
                    
                })
                //window.location.href = (url.replace(/ /g, '_'));
            }
            else{
                var selectedTime = new Date(Date.UTC(this.getSelectedDay.year, this.getSelectedDay.month, this.getSelectedDay.day, this.getSelectedHour));
                date = getUrlEncodedMeasurementHourFile(selectedTime);
                var url = '/api/download-weather&measurement='+ date+'&paramw='+downloadWeather.join(',')+'&zip='+localSettings.download.downlzip+'&time='+Date.now();
                //alert(url);
                url = url.replace(/ /g, '_');

                this.setDownloading({enabled: true, progress: 0, preparing:true})
                api.getFileAction(url,'GET','', (progress)=>{
                    let percentage = 100;
                    if (progress.total != 0) {
                        percentage = Math.round((progress.loaded/progress.total)*100);
                    }
                    this.setDownloadingProgress(percentage);
                })
                .then(()=>{
                    this.setDownloading({enabled: false, progress: 0})
                })
                .catch(()=>{
                    this.setDownloading({enabled: false, progress: 0})
                    
                })
                //window.location.href = (url.replace(/ /g, '_'));                
            }
        },
    }
}
</script>



// WEBPACK FOOTER //
// DownloadPopover.vue?5cb46935